// extracted by mini-css-extract-plugin
module.exports = {"customeTooltip":"styles_customeTooltip__0NqHf","tooltipLabel":"styles_tooltipLabel__j9qMN","tooltipValue":"styles_tooltipValue__KHca_"};